import { render, staticRenderFns } from "./XtendAlertsGenericMetadata.vue?vue&type=template&id=0c450648&scoped=true&"
import script from "./XtendAlertsGenericMetadata.vue?vue&type=script&lang=js&"
export * from "./XtendAlertsGenericMetadata.vue?vue&type=script&lang=js&"
import style0 from "./XtendAlertsGenericMetadata.vue?vue&type=style&index=0&id=0c450648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c450648",
  null
  
)

export default component.exports